export const COOKIE_TOKEN_KEY = '@quero-log/api-token';

export const USER_KEY = '@quero-log/user-key';

export const JSON_KEY = '@quero-log/json-key';

export const LOCALSTORAGE_URL_API_KEY = '@quero-log/url-api-key';

export const GET_INFOS_QUERY_KEY = 'GET_INFOS';

export const GET_PLACE_CONFIG_INFOS_QUERY_KEY = 'GET_PLACE_CONFIG_INFOS';

export const KEY_QL_MANAGER_SELECTED_CITY = '@ql-manager/selected-franchise';
